import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { TableRow, TableCell, Typography, MenuItem } from '@mui/material';
// components
import moment from 'moment';
import Label from '../../Label';
import Iconify from '../../../fl-components/Iconify';
import { TableMoreMenu } from '../../../fl-components/table';

// ----------------------------------------------------------------------

AttendanceRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func
};

export default function AttendanceRow({ row, selected, onEditRow }) {
  const theme = useTheme();

  const { createdAt, slotTimeFrom, slotTimeTo, absentStudents, presentStudents } = row;

  const [openMenu, setOpenMenuActions] = useState(null);

  const handleOpenMenu = (event) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover selected={selected}>
      <TableCell>
        <Typography variant="subtitle2" noWrap>
          {moment(createdAt).format('DD/MM/yyyy')}
        </Typography>
      </TableCell>

      <TableCell align="left">
        {moment(slotTimeFrom).format('LT')} - {moment(slotTimeTo).format('LT')}
      </TableCell>

      <TableCell align="left">
        <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="success">
          {presentStudents.length}
        </Label>
      </TableCell>

      <TableCell align="left">
        <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="error">
          {absentStudents.length}
        </Label>
      </TableCell>

      <TableCell align="right">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          actions={
            <MenuItem
              onClick={() => {
                onEditRow();
                handleCloseMenu();
              }}
            >
              <Iconify icon="eva:edit-fill" />
              Edit
            </MenuItem>
          }
        />
      </TableCell>
    </TableRow>
  );
}
